export default "/images/vendor/flag-icon-css/flags/4x3/kh.svg?09c49693fc10e5bd02ed2a12de8e3c6e";